  document.addEventListener('DOMContentLoaded', function() {
      // 移动端手风琴效果
      const navTitles = document.querySelectorAll('.nav-title');
      
      navTitles.forEach(title => {
        title.addEventListener('click', function() {
          if (window.innerWidth > 768) return;
          
          // 切换当前标题的活动状态
          const wasActive = title.classList.contains('accordion-active');
          
          // 移除其他所有活动状态
          navTitles.forEach(t => {
            if (t !== title) {
              t.classList.remove('accordion-active');
              t.nextElementSibling.classList.remove('accordion-expanded');
            }
          });
          
          // 切换当前状态
          title.classList.toggle('accordion-active', !wasActive);
          title.nextElementSibling.classList.toggle('accordion-expanded', !wasActive);
        });
      });
      
      // 处理窗口大小变化
      window.addEventListener('resize', function() {
        const isMobile = window.innerWidth <= 768;
        
        navTitles.forEach(title => {
          const navs = title.nextElementSibling;
          
          if (isMobile) {
            title.classList.remove('accordion-active');
            navs.classList.remove('accordion-expanded');
          } else {
            // PC端 - 强制显示所有
            title.classList.remove('accordion-active');
            navs.style.maxHeight = '';
            navs.classList.add('accordion-expanded');
          }
        });
      });
      
      // 初始化 - 移动端默认展开第一项
      // if (window.innerWidth <= 768) {
      //   const firstTitle = navTitles[0];
      //   if (firstTitle) {
      //     firstTitle.classList.add('accordion-active');
      //     firstTitle.nextElementSibling.classList.add('accordion-expanded');
      //   }
      // }
    });